module.exports = __webpack_public_path__ + "static/mobile-video-adbd07582e70b24fddaeae61994f101e.mp4";